import { render, staticRenderFns } from "./userMessage.vue?vue&type=template&id=afe68e52&"
import script from "./userMessage.vue?vue&type=script&lang=js&"
export * from "./userMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports